import { COUNTRY_FLAGS } from "@/constants/countrySelection";

/**
 * Returns a responsive modal width based on the current viewport width.
 * @returns width string
 */
export const getOnboardingVoucherModalWidth = (): string => {
  if (typeof window === "undefined") return "95vw";
  const width = window.innerWidth;
  if (width >= 1200) return "50vw"; // XL screens
  if (width >= 576) return "70vw"; // SM to XL screens
  return "95vw"; // Mobile screens - use 95vw instead of 100vw to prevent full page
};

/**
 * Determines whether a user account is considered new (created within the last 5 minutes).
 * @param createdAt - Unix timestamp (ms) of the account creation time, or null if unavailable.
 * @returns `true` if the account is less than 5 minutes old, `false` otherwise.
 */
export const isNewUser = (createdAt: number | null): boolean => {
  if (!createdAt) {
    return false;
  }
  const accAgeInMinutes = (Date.now() - createdAt) / 1000 / 60;
  return accAgeInMinutes < 5;
};

// TODO: Re-enable by removing the early `false` return once the voucher feature is ready
export const isOnboardingVoucherEnabled = (country: string | null) => {
  // Temporarily disabled - voucher feature is turned off globally
  return false;
  return (
    COUNTRY_FLAGS.find((c) => c.countryCode === country)
      ?.showOnboardingVoucher ?? false
  );
};
